import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Clock, ArrowRight } from 'lucide-react';
import SEO from '../components/SEO';
import { getFullUrl } from '../utils/url';
import { blogPosts } from '../data/blog';

const formatDate = (d) =>
  new Date(d).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });

const BlogList = () => (
  <div className="min-h-screen bg-cream">
    <SEO
      title="Blog - MMD CONSEIL | Conseils comptables & fiscaux pour dirigeants"
      description="Le blog de MMD CONSEIL : guides, conseils et analyses en comptabilité, fiscalité et gestion d'entreprise pour indépendants, TPE et PME à Lyon."
      keywords="blog expert-comptable Lyon, conseils fiscalité, guide micro-entreprise, gestion entreprise, MMD CONSEIL"
      url={getFullUrl('/blog')}
    />

    {/* Hero */}
    <section className="bg-primary-blue text-white pt-32 md:pt-40 pb-16 md:pb-20">
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <p className="text-xs uppercase tracking-[0.25em] font-semibold text-warm-accent mb-4">Le blog MMD CONSEIL</p>
        <h1 className="font-heading text-4xl md:text-6xl font-light tracking-tight">
          Guides pour dirigeants
        </h1>
        <p className="text-white/70 mt-6 max-w-2xl leading-relaxed">
          Décryptages, guides pratiques et analyses en comptabilité, fiscalité et gestion — pour prendre les bonnes décisions au bon moment.
        </p>
      </div>
    </section>

    {/* Articles */}
    <section className="section-spacing">
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {blogPosts.map((post) => (
            <Link
              key={post.slug}
              to={`/blog/${post.slug}`}
              data-testid={`blog-card-${post.slug}`}
              className="group flex flex-col bg-white rounded-3xl overflow-hidden border border-border-soft hover:shadow-xl transition-shadow duration-300"
            >
              <div className="h-52 overflow-hidden">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-7 flex flex-col flex-1">
                <div className="flex items-center gap-3 text-xs text-text-gray mb-3">
                  <span className="uppercase tracking-wider font-semibold text-warm-accent">{post.category}</span>
                  <span className="flex items-center gap-1"><Calendar className="w-3.5 h-3.5" />{formatDate(post.date)}</span>
                  <span className="flex items-center gap-1"><Clock className="w-3.5 h-3.5" />{post.readingTime}</span>
                </div>
                <h2 className="font-heading text-xl md:text-2xl font-medium text-primary-blue leading-snug mb-3 group-hover:text-warm-accent transition-colors duration-300">
                  {post.title}
                </h2>
                <p className="text-text-gray text-sm leading-relaxed line-clamp-3 mb-5">{post.excerpt}</p>
                <span className="mt-auto inline-flex items-center gap-2 font-medium text-primary-blue">
                  Lire l’article
                  <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  </div>
);

export default BlogList;
